import React, { Component } from 'react';
import Img from 'react-image'

class TeamIcon extends Component {

    render() {
        return (
            <Img unloader={<span>{this.props.teamName}</span>} src={'https://s3-eu-west-1.amazonaws.com/hidat-v3-0.ahrina.com/hidat-v3-0/app/hockeyinfo/resources/teams/' + this.props.teamId + '.png'} />
        );
    }
}

export default TeamIcon;


// WEBPACK FOOTER //
// ./src/GameList/TeamIcon.js